import { render, staticRenderFns } from "./BillingTerms.vue?vue&type=template&id=550b8684"
import script from "./BillingTerms.vue?vue&type=script&lang=js"
export * from "./BillingTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports